import * as types from './types';

const INITIAL_STATE = {
  recipeGroups: [],
  loading: false,

  error: null,

  writeSuccessful: false,
  deleteSuccessful: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_RECIPE_GROUPS_LOADING:
    case types.WRITE_RECIPE_GROUPS_LOADING:
    case types.DELETE_RECIPE_GROUP_LOADING:
      return {
        ...state,
        loading: action.payload,
        deleteSuccessful: false,
        writeSuccessful: false,
      };
    case types.DELETE_RECIPE_GROUP_ERROR:
    case types.WRITE_RECIPE_GROUPS_ERROR:
    case types.GET_RECIPE_GROUPS_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case types.DELETE_RECIPE_GROUP_SUCCESS:
      return {
        ...state,
        recipeGroups: action.payload,
        deleteSuccessful: true,
      };
    case types.WRITE_RECIPE_GROUPS_SUCCESS:
      return {
        ...state,
        recipeGroups: action.payload,
        writeSuccessful: true,
      };
    case types.GET_RECIPE_GROUPS_SUCCESS:
      return {
        ...state,
        recipeGroups: action.payload,
      };
    case types.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/recipeGroup/reducer.js